import { render, staticRenderFns } from "./ForumDetail.vue?vue&type=template&id=f66f4278&scoped=true&"
import script from "./ForumDetail.vue?vue&type=script&lang=js&"
export * from "./ForumDetail.vue?vue&type=script&lang=js&"
import style0 from "./ForumDetail.vue?vue&type=style&index=0&id=f66f4278&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66f4278",
  null
  
)

/* custom blocks */
import block0 from "./ForumDetail.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports